module.exports = __webpack_public_path__ + "static/media/userblue.42aa872e.svg";